import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import optimizely, { optimizelyFeatures } from 'api/optimizely';
import graphql from 'api/graphql';
import CONTENT_TYPES from 'globalConst/contentTypes-const';
import { isUserOnJuke as getIsUserOnJuke } from 'store/reducers/trackers';
import { getIsLoggedIn } from 'store/reducers/user';
import { getProgressUpdated } from 'store/reducers/player';
import logger from 'util/logger';

const PROGRESS_INTERVAL = 300000; // 5min inverval

export default function useFetchProgress({ contentTypeId, slug } = {}) {
  const isUserLoggedIn = useSelector(getIsLoggedIn);
  const isUserOnJuke = useSelector(getIsUserOnJuke);
  const progressUpdated = useSelector(getProgressUpdated);
  const [progress, setProgress] = useState(null);
  const includeProgress = optimizely.isFeatureEnabled(optimizelyFeatures.FETCH_PROGRESS);

  useEffect(() => {
    let progressIntervalUpdate;
    let unmounted;
    async function fetchProgress() {
      try {
        const response = await graphql.fetchProgress({ slug, contentTypeId });
        if (!unmounted) {
          setProgress(response);
        }
      } catch (error) {
        logger.error(`Error ${error} while fetchProgress with graphQL for ${slug} | ${contentTypeId}`);
      }
    }

    if (
      slug &&
      includeProgress &&
      isUserLoggedIn &&
      [CONTENT_TYPES.SHOW, CONTENT_TYPES.PODCAST].includes(contentTypeId)
    ) {
      if (isUserOnJuke) {
        fetchProgress();
        progressIntervalUpdate = setInterval(fetchProgress, PROGRESS_INTERVAL);
      } else {
        clearInterval(progressIntervalUpdate);
      }
    }
    return () => {
      clearInterval(progressIntervalUpdate);
      unmounted = true;
    };
  }, [slug, isUserOnJuke, contentTypeId, includeProgress, isUserLoggedIn, progressUpdated]);

  return progress;
}
